<template>

    <div>
        <app-header :settings="settings"></app-header>

        <div class="page__main container">
            <div class="page__index block">
                <div class="add-entity">
                    <div class="add-entity__form">
                        <div class="line-form b-form">
                            <div class="line-form__caption ex-small">
                                Укажите логин и пароль, выданный при заключении соглашения об использованиии Личного кабинета юридических лиц
                            </div>
                            <div class="line-form__body block-wrap">
                                <div class="line-form__col block">
                                    <label class="txt-input">
                                        <div class="txt-input__label">Логин</div>
                                        <div class="txt-input__input">
                                            <input class="txt-input__field input req" type="text" v-model="login">
                                        </div>
                                    </label>
                                </div>
                                <div class="line-form__col block">
                                    <label class="txt-input">
                                        <div class="txt-input__label">Пароль</div>
                                        <div class="txt-input__input">
                                            <input class="txt-input__field input req" type="password" v-model="password">
                                        </div>
                                    </label>
                                </div>
                                <div class="line-form__col line-form__col--total block">
                                    <a class="line-form__button button button--th-main"
                                       :class="[getStatusClass, getDisabledClass]"
                                       @click="addDeclarers"
                                       v-if="declarers.length > 0">{{ isChecking ? '' : 'Добавить Заявителя' }}</a>
                                    <a class="line-form__button button button--th-main"
                                       :class="[getStatusClass, getButtonClass]"
                                       @click="getAvailableDeclarers"
                                       v-else>{{ isChecking ? '' : 'Поиск Заявителей' }}</a>

                                </div>
                            </div>
                            <div class="line-form__body block-wrap" v-if="responseError">
                                <div class="line-form__col block">
                                    <p class="status-error">{{ responseError }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-entity__list" v-if="declarers.length > 0">
                        <div class="form-list">
                            <div class="form-list__line">
                                <label class="radio-row">
                                    <input type="checkbox" name="profile" class="radio-row__radio" v-model="checkAll">
                                    <div class="radio-row__check radio-row__check--checkbox"></div>
                                    <div class="radio-row__body">
                                        <div class="radio-row__head">Выбрать всех заявителей</div>
                                    </div>
                                </label>
                            </div>

                            <div class="form-list__line" v-for="declarer in declarers">
                                <label class="radio-row">
                                    <input type="checkbox" name="profile" class="radio-row__radio" v-model="selectedDeclarers" :value="declarer">
                                    <div class="radio-row__check radio-row__check--checkbox"></div>
                                    <div class="radio-row__body">
                                        <div class="radio-row__head">
                                            {{ declarer.declarerType == 1 ? "Юридическое лицо" : "" }}
                                            {{ declarer.declarerType == 2 ? "Физическое лицо" : "" }}
                                            {{ declarer.declarerType == 3 ? "Индивидуальный предприниматель" : "" }}
                                            {{ declarer.declarerType == 4 ? "ОМСУ" : "" }}
                                        </div>
                                        <div class="radio-row__right radio-row__right--cols">
                                            <div class="radio-row__caption h4">Заявитель 
                                            <span class="status-primary">
                                                 {{ declarer.ulBasicInfo ? declarer.ulBasicInfo.name : "" }}
                                                 {{ declarer.flBasicInfo ? declarer.flBasicInfo.fio.lastName : "" }}
                                                 {{ declarer.municipalBasicInfo ? declarer.municipalBasicInfo.name : "" }}
                                                 {{ declarer.individualEmployerBasicInfo ? declarer.individualEmployerBasicInfo.fio.lastName : "" }}
                                             </span>
                                            </div>
                                            <div class="radio-row__status">
                                                <!--<div class="status-primary">Активен</div>-->
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

   import ProfilesHeader from './ProfilesHeader.vue';

    export default {
        name: 'add-declarer',
        data: function () {
            return {
                settings: {
                    name: 'declarers',
                    isAddAccount: true,
                    addAccountHeader: 'Добавление заявителя СТС'
                },
                login: '',
                password: '',
                isChecking: false,
                responseStatus: false,
                responseError: '',
                accounts: [],
                selectedAccounts: [],
                declarers: [],
				selectedDeclarers: []
            }
        },
        components: {
            'app-header': ProfilesHeader,
        },
        filters: {
            formatDate(value) {
                if (value)
                    return moment(value).format('DD.MM.YYYY');

                return "";
            }
        },
        computed: {
            getStatusClass() {
                return this.isChecking ? 'is-overlay' : ''
            },
            getButtonClass() {
                return !this.password || !this.login ? 'disabled' : ''
            },
            getDisabledClass() {
                return this.selectedDeclarers.length > 0 ? '' : 'disabled'
            },
            checkAll: {
                get: function () {
                    return this.declarers ? this.selectedDeclarers.length == this.declarers.length : false;
                },
                set: function (value) {
                    var self = this
                    var selected = [];

                    if (value && this.declarers) {
                        self.declarers.forEach(function (decl) {
                            selected.push(decl);
                        });
                    }

                    this.selectedDeclarers = selected;
                }
            }
        },
        methods: {
            getAvailableDeclarers() {
                var self = this

                self.isChecking = true
                self.responseStatus = false
                self.responseError = ''
                self.declarers = []

                axios.post('/Profiles/GetAvailableDeclarers', {
                    Login: self.login.trim(),
                    Password: self.password.trim(),
                })
                    .then(function (response) {
                        self.responseStatus = response.data.success
                        self.responseError = response.data.responseError 

                        if (response.data.success)
                            self.declarers = response.data.data 
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                        self.isChecking = false;
                    });
            },
            addDeclarers() {
                var self = this

                self.isChecking = true

                axios.post('/Profiles/AddDeclarers', self.selectedDeclarers)
                    .then(function (response) {
						document.location.href = '/Profiles/Declarers'
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {                        
                    });
            },
            checkAll() {
                this.selectedDeclarers = [];

                if (!this.selectedDeclarers) {
                    for (declarer in this.selectedDeclarers) {
                        this.selectedDeclarers.push(declarer);
                    }
                }
            }
        }
    }

</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/AddDeclarer.vue